import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/a2z2.jpg";

function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // Close menu on resize to desktop
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 900) setOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <header className="navbar">
      <div className="navbar-left">
        <img src={logo} alt="logo" className="logo" />
      </div>

      {/* Desktop nav */}
      <nav className="navbar-center">
        <NavLink to="/" end className="nav-link" onClick={() => setOpen(false)}>
          Home
        </NavLink>

        <NavLink
          to="/services"
          className="nav-link"
          onClick={() => setOpen(false)}
        >
          Our Services
        </NavLink>

        <NavLink
          to="/about"
          className="nav-link"
          onClick={() => setOpen(false)}
        >
          About Us
        </NavLink>

        <NavLink
          to="/contact"
          className="nav-link"
          onClick={() => setOpen(false)}
        >
          Contact Us
        </NavLink>
      </nav>

      <div className="navbar-right">
        <button
          className="book-btn"
          onClick={() => {
            setOpen(false);
            navigate("/contact");
          }}
        >
          Book Now
        </button>

        {/* Mobile hamburger */}
        <button
          className="burger"
          type="button"
          aria-label="Open menu"
          aria-expanded={open}
          onClick={() => setOpen((s) => !s)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile menu panel */}
      {open && (
        <div className="mobile-menu" role="dialog" aria-label="Mobile menu">
          <NavLink
            to="/"
            end
            className="mobile-link"
            onClick={() => setOpen(false)}
          >
            Home
          </NavLink>

          <NavLink
            to="/services"
            className="mobile-link"
            onClick={() => setOpen(false)}
          >
            Our Services
          </NavLink>

          <NavLink
            to="/about"
            className="mobile-link"
            onClick={() => setOpen(false)}
          >
            About Us
          </NavLink>

          <NavLink
            to="/contact"
            className="mobile-link"
            onClick={() => setOpen(false)}
          >
            Contact Us
          </NavLink>

          <button
            className="mobile-book"
            type="button"
            onClick={() => {
              setOpen(false);
              navigate("/contact");
            }}
          >
            Book Now
          </button>
        </div>
      )}
    </header>
  );
}

export default Navbar;
